import React, { useState } from "react";
import { useStore } from "../StateProvider";
import { FaChevronRight } from "react-icons/fa";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import "./sider.css";

const Sider = ({ menus, setsider }) => {
  const store = useStore();
  const [sidemenu, setsidemenu] = useState(menus);
  const isCollapsed = store.getsystemvalue("sidebar_collapsed") || false;

  const toggleCollapse = () => {
    store.setsystemvalue("sidebar_collapsed", !isCollapsed);
  };

  function open(menu, isOpen) {
    menu = menu.replace("`", "");
    let position = "";
    menu.split("`").map((item) => (position += "['" + item + "'].child"));
    position = position.substring(0, position.length - 6);

    position =
      "sidemenu" +
      position +
      "['meta-data'].open = !sidemenu" +
      position +
      "['meta-data'].open";

    eval(position);
    setsidemenu({ ...sidemenu });
  }

  return (
    <div className="flex flex-col h-full justify-between py-6 px-3">
      <div className="flex-1 overflow-y-auto custom-scrollbar pr-1">
        <Menus
          obj={sidemenu}
          open={open}
          parent={""}
          setsider={setsider}
          isCollapsed={isCollapsed}
          expandSidebar={() => store.setsystemvalue("sidebar_collapsed", false)}
        />
      </div>

      {/* Collapse Toggle Footer Button */}
      <div className="border-t border-white/10 pt-4 mt-2 flex items-center justify-center">
        <button
          onClick={toggleCollapse}
          className="flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 hover:bg-white/15 text-slate-300 hover:text-white transition-all border-0 cursor-pointer"
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
        >
          {isCollapsed ? <FiChevronsRight size={20} /> : <FiChevronsLeft size={20} />}
        </button>
      </div>
    </div>
  );
};

function Menus({ obj, parent, open, setsider, isCollapsed, expandSidebar }) {
  return Object.keys(obj).map((head, index) => {
    if (!obj[head].disabled) {
      return (
        <Menu
          key={index}
          heading={head}
          icon={obj[head]["meta-data"].icon}
          parent={obj[head]["meta-data"].parent}
          onClick={() => {
            if (isCollapsed) {
              expandSidebar();
              // Delay opening submenu slightly so sidebar expansion looks smooth
              setTimeout(() => {
                open(parent + "`" + head, obj[head]["meta-data"].open);
              }, 150);
            } else {
              open(parent + "`" + head, obj[head]["meta-data"].open);
            }
          }}
          open={obj[head]["meta-data"].open}
          link={obj[head].link}
          button={obj[head].button}
          setsider={setsider}
          isCollapsed={isCollapsed}
          expandSidebar={expandSidebar}
        >
          {obj[head].child && !isCollapsed && (
            <Menus
              obj={obj[head].child}
              open={open}
              parent={parent + "`" + head}
              setsider={setsider}
              isCollapsed={isCollapsed}
              expandSidebar={expandSidebar}
            />
          )}
        </Menu>
      );
    }
    return null;
  });
}

function Menu({
  heading,
  icon,
  parent,
  children,
  onClick,
  open,
  link,
  button,
  setsider,
  isCollapsed,
}) {
  const store = useStore();
  const location = useLocation();
  
  // Clean up dashes or prefixes for clean visual look
  const cleanHeading = heading.replace(/^–\s*/, "");

  const isActive = link ? (location.pathname === link || (link !== "/" && location.pathname.startsWith(link))) : false;

  return (
    <div className="flex flex-col w-full">
      <div
        className={`flex items-center relative gap-3 cursor-pointer rounded-xl transition-all duration-200 group py-2.5 px-4 mb-1
          ${isActive 
            ? "shadow-md font-semibold" 
            : "hover:bg-white/10 hover:text-white"
          }
        `}
        style={{
          marginLeft: !isCollapsed && parent ? "12px" : "0px",
          backgroundColor: isActive ? '#FFFFFF' : 'transparent',
          color: isActive ? '#000042' : '#CBD5E1',
        }}
        title={isCollapsed ? cleanHeading : undefined}
        onClick={(e) => {
          e.preventDefault();
          if (!link && !button) {
            onClick();
          }
          if (link && !button) {
            store.navTo(link);
            setsider("max-sm:hidden");
          }
          if (button !== undefined && link === undefined) {
            switch (button.toLowerCase()) {
              case "logout":
                store.logout();
                setsider("max-sm:hidden");
                break;
              default:
                break;
            }
          }
        }}
      >
        {/* Left active line indicator */}
        {isActive && (
          <span className="absolute left-0 top-1/4 bottom-1/4 w-1 bg-[#4F46E5] rounded-r-md"></span>
        )}

        {/* Menu Icon */}
        <div className={`text-xl flex-shrink-0 transition-transform duration-200 group-hover:scale-105
          ${isActive ? "text-[#4F46E5]" : "text-[#94A3B8] group-hover:text-white"}
        `}>
          {icon || <span className="w-1.5 h-1.5 rounded-full bg-slate-400 group-hover:bg-white"></span>}
        </div>

        {/* Menu Text & Expand Chevron */}
        {!isCollapsed && (
          <div className="flex items-center justify-between w-full">
            <span className="text-xs tracking-wide">{cleanHeading}</span>
            {!link && !button && (
              <FaChevronRight
                className={`w-2.5 h-2.5 transition-transform duration-200 opacity-60 group-hover:opacity-100
                  ${open ? "rotate-90" : ""}
                `}
              />
            )}
          </div>
        )}
      </div>

      {/* Children Submenu items with visual group borders */}
      {open && children && !isCollapsed && (
        <div className="ml-6 pl-3 border-l border-white/10 flex flex-col gap-0.5 mt-0.5 mb-1.5">
          {children}
        </div>
      )}
    </div>
  );
}

export default Sider;
